export function unwrapField(value) {
  if (value == null) {
    return undefined;
  }
  if (typeof value === 'object' && !Array.isArray(value)) {
    if (value.sys?.type === 'Link' || value.fields?.file) {
      return value;
    }
    const first =
      value['en-US'] ?? Object.values(value).find((v) => v != null);
    return first;
  }
  return value;
}

export function unwrapLinkField(field) {
  if (field == null) {
    return undefined;
  }
  if (typeof field !== 'object' || Array.isArray(field)) {
    return field;
  }
  if (
    field.sys?.type === 'Link' ||
    field.sys?.type === 'ResourceLink' ||
    field.fields?.file
  ) {
    return field;
  }
  return field['en-US'] ?? Object.values(field).find((v) => v != null);
}

export function parseContentfulDate(dateRaw) {
  if (dateRaw == null || dateRaw === '') {
    return null;
  }
  const str = String(dateRaw);
  const ymd = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (ymd) {
    const y = parseInt(ymd[1], 10);
    const m = parseInt(ymd[2], 10) - 1;
    const d = parseInt(ymd[3], 10);
    return new Date(y, m, d);
  }
  const parsed = new Date(str);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatMonthYear(date) {
  if (!date || Number.isNaN(date.getTime())) {
    return '';
  }
  return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}

export function formatLongDate(date) {
  if (!date || Number.isNaN(date.getTime())) {
    return '';
  }
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}

function assetIdFromResourceLink(link) {
  if (link?.sys?.id) {
    return link.sys.id;
  }
  const urn = link?.sys?.urn;
  if (typeof urn !== 'string') {
    return null;
  }
  const m = urn.match(/\/assets\/([^/?#]+)\s*$/);
  return m ? m[1] : null;
}

export function resolveAssetUrl(fieldValue, assetsById) {
  if (!fieldValue) {
    return null;
  }
  let asset = fieldValue;
  if (fieldValue.sys?.type === 'Link' && fieldValue.sys.linkType === 'Asset') {
    if (!assetsById) {
      return null;
    }
    asset = assetsById.get(fieldValue.sys.id) || null;
  } else if (
    fieldValue.sys?.type === 'ResourceLink' &&
    assetsById &&
    (fieldValue.sys.linkType === 'Contentful:Asset' ||
      fieldValue.sys.linkType === 'Asset')
  ) {
    const id = assetIdFromResourceLink(fieldValue);
    asset = id ? assetsById.get(id) || null : null;
  }
  if (!asset?.fields) {
    return null;
  }
  const rawFile = asset.fields.file;
  const file =
    rawFile && typeof rawFile === 'object' && 'url' in rawFile && !rawFile.sys
      ? rawFile
      : unwrapField(rawFile) ?? rawFile;
  const url =
    file && typeof file === 'object' && typeof file.url === 'string'
      ? file.url
      : null;
  if (!url) {
    return null;
  }
  const str = String(url);
  return str.startsWith('//') ? `https:${str}` : str;
}
